module.exports = __webpack_public_path__ + "img/table_grey.78d6aa39.svg";